
export const FETCH_IS_CHECKER_REQUEST = 'FETCH_IS_CHECKER_REQUEST';
export const FETCH_IS_CHECKER_REQUEST_COMPLETED = 'FETCH_IS_CHECKER_REQUEST_COMPLETED';
export const FETCH_IS_CHECKER_REQUEST_ERROR = 'FETCH_IS_CHECKER_REQUEST_ERROR';

export const FETCH_CUSTOMER_REQUEST = 'FETCH_CUSTOMER_REQUEST';
export const FETCH_CUSTOMER_REQUEST_COMPLETED = 'FETCH_CUSTOMER_REQUEST_COMPLETED';
export const FETCH_CUSTOMER_REQUEST_ERROR = 'FETCH_CUSTOMER_REQUEST_ERROR';
export const FETCH_CUSTOMER_RESET = 'FETCH_CUSTOMER_RESET';

export const FETCH_CUSTOMER_LIST_REQUEST = 'FETCH_CUSTOMER_LIST_REQUEST';
export const FETCH_CUSTOMER_LIST_REQUEST_COMPLETED = 'FETCH_CUSTOMER_LIST_REQUEST_COMPLETED';
export const FETCH_CUSTOMER_LIST_REQUEST_ERROR = 'FETCH_CUSTOMER_LIST_REQUEST_ERROR';
export const FETCH_CUSTOMER_LIST_RESET = 'FETCH_CUSTOMER_LIST_RESET';

export const ADD_CUSTOMER_INITIAL = 'ADD_CUSTOMER_INITIAL';
export const ADD_CUSTOMER_REQUEST = 'ADD_CUSTOMER_REQUEST';
export const ADD_CUSTOMER_REQUEST_COMPLETED = 'ADD_CUSTOMER_REQUEST_COMPLETED';
export const ADD_CUSTOMER_REQUEST_ERROR = 'ADD_CUSTOMER_REQUEST_ERROR';


// WEBPACK FOOTER //
// ./constants/customerdetails.js